import cns from 'classnames'
import { BigNumber } from 'ethers'
import { memo } from 'react'
import { useWeb3 } from 'modules/blockChain/hooks/useWeb3'
import { useEthBalance } from 'modules/pools/hooks/useEthBalance'

import { Text } from 'shared/ui/common/Text'
import { RoundCTAButton } from 'shared/ui/controls/RoundCTAButton'

import { Chains } from 'modules/blockChain/chains'
import { weiToNum } from 'modules/blockChain/utils/parseWei'
import { formatAsset } from 'modules/pools/utils/formatAsset'
import { getNativeTokenLabel } from 'modules/pools/utils/getNativeTokenLabel'
import { DEFAULT_DECIMALS } from 'modules/pools/constants/poolAssets'
import { ONE_INCH_POLYGON_LINK } from 'shared/constants/links'

import s from './EstimatedGasFee.module.scss'

type Props = {
  value: BigNumber
  withCta?: boolean
  className?: string
  classNameCta?: string
}

export const EstimatedGasFee = memo((props: Props) => {
  const { value, withCta = true, className, classNameCta } = props
  const { chainId } = useWeb3()

  const isOnPolygon = chainId === Chains.Polygon

  const nativeTokenLabel = getNativeTokenLabel(chainId)

  const gasFeeNum = weiToNum(value, DEFAULT_DECIMALS)
  const { data: ethBalanceWei } = useEthBalance()
  const isEthBalanceInsufficient = ethBalanceWei
    ? value.gt(ethBalanceWei)
    : false

  return (
    <>
      <Text
        size={14}
        weight={500}
        color="secondary"
        className={cns(s.text, className)}
      >
        Estimated Gas fee:{' '}
        <span>
          {formatAsset(gasFeeNum, nativeTokenLabel)} {nativeTokenLabel}
        </span>{' '}
        {/* TODO: figure out how to get latest price for a native token */}
        {/* ({formatAsset(gasFeeUsd, 'USD')} USD) */}
      </Text>
      {withCta && isEthBalanceInsufficient && isOnPolygon && (
        <RoundCTAButton
          size={256}
          borderOffset={16}
          href={ONE_INCH_POLYGON_LINK}
          className={cns(s.cta, classNameCta)}
        >
          <span>
            You don’t have <br /> enough of {nativeTokenLabel} for <br />{' '}
            transaction
          </span>
          <span>Get {nativeTokenLabel} here</span>
        </RoundCTAButton>
      )}
    </>
  )
})
